import { simpleAjaxDispatch } from './http';

export function patchAccreditationClaim(constituentId, accreditationId, json) {
  return simpleAjaxDispatch(
    `/constituents/${constituentId}/claims/${accreditationId}`,
    'patchAccreditationClaim',
    { method: 'PATCH', meta: { constituentId, accreditationId }, json },
  );
}

export function fetchAccreditationClaim(constituentId, accreditationId) {
  return simpleAjaxDispatch(
    `/constituents/${constituentId}/claims/${accreditationId}`,
    'fetchAccreditationClaim',
    { useSeq: true, meta: { constituentId, accreditationId }},
  );
}
